export enum ClubRequestTypes {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    ACCEPTABLE = 'ACCEPTABLE' //ATTENZIONE => STATO FITTIZIO CHE SERVE A FAR CAPIRE A BE CHE SI RICHIEDONO SIA LE RICHIESTE PENDING CHE QUELLE REJECTED
}